<kendo-dialog (close)="closeDialog()" [maxWidth]="1900" [width]="900" [minHeight]="300"
    (click)="$event.stopPropagation()">
    <h4 class="k-w-full heading-cls" *ngIf="!isReAssign">
        Assign
    </h4>
    <h4 class="k-w-full heading-cls" *ngIf="isReAssign">
        Reassign
    </h4>
    <div class="dialog-body">
        <div class="loading-container" *ngIf="loadSpinner">
            <kendo-loader *ngIf="loadSpinner" type="converging-spinner" size="large"></kendo-loader>
        </div>
        <div>
            <app-staff-search #staff (onSelectedStaff)="staffSelected()" (onResetSearch)="resetSearch($event)"
                [readOnly]="true"></app-staff-search>
        </div>

        <div>

        </div>
    </div>
    <kendo-dialog-actions>
        <div class=" k-mt-2 k-text-right margin  ">
            <div class="action-btns   footer">
                <div class="action-btns__right">
                    <button kendoButton size="large" rounded="large" fillMode="outline" themeColor="error"
                        (click)="closeDialog()">
                        Cancel
                    </button>
                    &nbsp;
                    <button kendoButton size="large" rounded="large" [disabled]="!selectedSearch || loadSpinner"
                        (click)="submit()" fillMode="solid" themeColor="primary">
                        Submit
                    </button>
                </div>
            </div>
        </div>
    </kendo-dialog-actions>
</kendo-dialog>